import React, { useEffect, useState } from "react";
import { Breadcrumb, Button, ButtonGroup, Col, Glyphicon, Modal, Row, Table } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { useEventContext } from "../../../context";
import locale from "../../../locale";
import DeleteConfirmOverlay from "../../UI/DeleteConfirmOverlay";
import {
    createEventNotification,
    deleteEventNotification,
    getEventNotifications,
    sendEventNotification,
    updateEventNotification,
    updateEventNotificationPoster
} from "../../../../api/cp/eventNotifications";
import EventNotificationModal from "./EventNotificationModal";
import ConfirmOverlay from "../../UI/ConfirmOverlay";

export default () => {
    const { event } = useEventContext();

    const [notifications, setNotifications] = useState([]);
    const [editingNotification, setEditingNotification] = useState(null);
    const [isSaving, setSaving] = useState(false);

    const getNotifications = async () => {
        try {
            const _notifications = await getEventNotifications(event.eventKey);
            setNotifications(_notifications);
        } catch (e) {
            console.error(e)
        }
    }

    useEffect(() => {
        getNotifications();
    }, []);

    const handleAddNotification = async () => {
        setSaving(true);
        try {
            const notification = await createEventNotification(event.eventKey, { event_id: event.id, name: 'Новое сообщение', text: '', link: '', time: 0, });
            setNotifications(notifications => [...notifications, notification])
            setEditingNotification(notification);
        } catch (e) {
            console.error(e)
        } finally {
            setSaving(false);
        }
    }

    const handleSaveNotification = async (file) => {
        setSaving(true);
        try {
            const formData = new FormData();
            formData.append('banner', file);
            let notification = await updateEventNotification(editingNotification?.id, editingNotification);
            if (file) {
                notification = await updateEventNotificationPoster(editingNotification?.id, formData);
            }
            setNotifications(notifications => notifications.map(_notification => _notification.id === editingNotification?.id ? notification : _notification));
            setEditingNotification(null);
        } catch (e) {
            console.error(e)
        } finally {
            setSaving(false);
        }
    }

    const handleSendNotification = (notificationID) => {
        try {
            sendEventNotification(notificationID);
        } catch (e) {
            console.error(e)
        }
    }

    const handleDeleteNotification = async (notificationID) => {
        try {
            await deleteEventNotification(notificationID);
            setNotifications(notifications => notifications.filter(({ id }) => id !== notificationID))
        } catch (e) {
            console.error(e)
        }
    }

    return (
        <>
            <Breadcrumb>
                <LinkContainer to={`/event/${event.eventPassword}`}>
                    <Breadcrumb.Item>{locale('mainMenu.interactive')}</Breadcrumb.Item>
                </LinkContainer>
                <Breadcrumb.Item active>{locale('mainMenu.eventNotifications')}</Breadcrumb.Item>
            </Breadcrumb>
            <Row>
                <Col xs={12}>
                    <Button onClick={handleAddNotification} bsStyle="success">Добавить</Button>
                </Col>
            </Row>

            <Table>
                <thead>
                    <tr>
                        <th width={40}>ID</th>
                        <th>Название</th>
                        <th width={150}></th>
                    </tr>
                </thead>
                <tbody>
                    {notifications.map(notification => (
                        <tr key={notification.id}>
                            <td>{notification.id}</td>
                            <td>{notification.name}</td>
                            <td>
                                <ButtonGroup>
                                    <Button bsSize="small" onClick={() => setEditingNotification(notification)}><Glyphicon glyph="pencil" /></Button>
                                    <ConfirmOverlay title="Отправить это сообщение?" buttonText="Отправить" onConfirm={() => handleSendNotification(notification.id)}>
                                        <Button bsSize="small"><Glyphicon glyph="send" /></Button>
                                    </ConfirmOverlay>
                                    <DeleteConfirmOverlay title="Точно удалить сообщение?" buttonText="Удалить" onConfirm={() => handleDeleteNotification(notification.id)}>
                                        <Button bsSize="small" bsStyle="danger"><Glyphicon glyph="trash" /></Button>
                                    </DeleteConfirmOverlay>
                                </ButtonGroup>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            <Modal show={!!editingNotification} onHide={() => setEditingNotification(null)}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Настройка сообщения
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <EventNotificationModal
                        notification={editingNotification}
                        onEditProperty={(key, value) => setEditingNotification(notification => ({ ...notification, [key]: value }))}
                        onSave={handleSaveNotification}
                        isSaving={isSaving}
                    />
                </Modal.Body>
            </Modal>
        </>
    );
}

